// src/components/ColumnFilter.js
import React, { useState } from "react";
import Select from "react-select";

import Typography from "@mui/material/Typography";

import { getFinalKeySegment, snakeToTitle } from "../utils";
import { columnOverrides } from "../labels";

let initialSelectedColumns = [];
let columnOptions = [];

const ColumnFilter = ({ columns, onFilter, defaultColumns }) => {
  // Transform the available columns into options for react-select
  if (columnOptions.length === 0 && columns) {
    columnOptions = columns.map((col) => {
      var colName = getFinalKeySegment(col);
      return {
        value: colName,
        label:
          colName in columnOverrides
            ? columnOverrides[colName]
            : snakeToTitle(colName),
      };
    });
  }
  // Transform the initial columns into options for react-select
  if (initialSelectedColumns.length === 0 && defaultColumns) {
    initialSelectedColumns = defaultColumns.map((col) => {
      var colName = getFinalKeySegment(col);
      return {
        value: colName,
        label:
          colName in columnOverrides
            ? columnOverrides[colName]
            : snakeToTitle(colName),
      };
    });
  }

  const [selectedColumns, setSelectedColumns] = useState(
    initialSelectedColumns,
  );

  const handleChange = (selectedOptions) => {
    console.log(selectedOptions);
    const selectedColumnNames = selectedOptions.map((option) => option.value);
    setSelectedColumns(selectedOptions);
    onFilter(selectedColumnNames.join(","));
  };

  return (
    <div style={{ textAlign: "left" }} className="mb-3">
      <Typography
        style={{ paddingLeft: "5px" }}
        variant="subtitle1"
        component="p"
      >
        Select Columns to Display:
      </Typography>
      <Select
        isMulti
        options={columnOptions}
        value={selectedColumns}
        onChange={handleChange}
        //placeholder="Select columns to filter"
      />
    </div>
  );
};

export default ColumnFilter;
